module.exports = __webpack_public_path__ + "img/jingmi5kg.3c1f653f.jpg";